import React, { useEffect, useState } from "react";
import MenuButtons from "../../components/MenuButtons";
// import PinPopup from "../../components/PinPopup";
import { fetchJobs, fetchChildSavingsInfo, completeJobForChild } from "../../services/Api";
import { useAuth } from "../../services/AuthContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useToast } from '../../services/ToastContext';
import ConfirmationPopup from "../../components/ConfirmationPopup";
import { useRefresh } from "../../services/RefreshContext";

const JobsPage = () => {
  const { childID, familyID } = useAuth();
  const { showToast } = useToast();
  const { refreshCounter, triggerRefresh } = useRefresh();

  const [jobs, setJobs] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [error, setError] = useState("")
  const [isSpinnerLoading, setIsSpinnerLoading] = useState(true);
  const [isConfirmationPopupOpen, setIsConfirmationPopupOpen] = useState(false);
  const [confirmingJob, setConfirmingJob] = useState("");

  useEffect(() => {
    setIsSpinnerLoading(true);
    const fetchData = async () => {
      try {
        const minDelay = new Promise(resolve => setTimeout(resolve, 200));
        const [jobsRes, childSavingsRes] = await Promise.all([
          fetchJobs(familyID),
          fetchChildSavingsInfo(childID),
          minDelay
        ]);
        setJobs(jobsRes.jobs);
        setFirstName(childSavingsRes?.childInfo.firstName);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsSpinnerLoading(false);
      }
    }
 
    fetchData()
  }, [childID, familyID, refreshCounter]);

  const dateFormatter = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });


  const handleJobClick = (e, job) =>{
    e.preventDefault();

    setConfirmingJob(job)
    setIsConfirmationPopupOpen(true)
  };

  const handleConfirm = (job) =>{

    const completeJob = async (childID, job, familyID) => {
      try {
        await completeJobForChild(childID, job, familyID);
        setError("");
        
        triggerRefresh();
        setConfirmingJob("");
        setIsConfirmationPopupOpen(false);
        showToast("Job complete! Time for grown up check-off!");
      } catch (error) {
        setError(error.message || 'Failed to confirm job')
      }
    };
  completeJob(childID, job, familyID);
  };

  return (
    <>
      <MenuButtons />
      <LoadingSpinner isLoading={isSpinnerLoading} />
      {/* add a div fade-in and conditional visible classes to get fade in for content working*/}
      <div className={`fade-in ${!isSpinnerLoading ? "visible" : ""}`}>
        <div className="centerTheMenuButtons">
          <div className="jobPageGrid">
            {jobs && jobs.length !== 0 ? (

              jobs.map((job) => (
                <div className="jobPageCard" key={job.JobID}>
                  <p className="jobPageDescription">{job.JobName}</p>
                  <div className="jobPageDetails">
                    <span className="jobPageEarnings">Reward: {<br />} ${job.PaymentAmount}</span>
                    <span className="jobPageDate">Created: {<br />}{job.DateCreated ? dateFormatter.format(new Date(job.DateCreated)) : ""}</span >
                  </div>
                  <button
                    className="job-complete-button globalButton" style={{ padding: "10px" }} onClick={(e) => handleJobClick(e,job)}
                  >
                    Check Off Job
                  </button>

                </div>
              ))
            ) : (
              <h4 className="text-muted text-center">No Jobs Available</h4>
            )}
          </div>
        </div>
      </div>
      <ConfirmationPopup
        isOpen={isConfirmationPopupOpen}
        onClose={() => {
          setIsConfirmationPopupOpen(false);
          setConfirmingJob("");
        }}
        removeJob={confirmingJob}
        content={
          <>
            <h4>Did you complete "{confirmingJob?.JobName}"?</h4>
          </>
        }
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default JobsPage;
